module.exports = __webpack_public_path__ + "static/media/upgrade_screen_logo.5a7efa09.png";